export const NewsStatus = {
    Public: 'public',
    Closed: 'closed',
    Private: 'private',
};
export const newNews = (input) => {
    const now = new Date();
    return {
        ...input,
        createdAt: now,
        updatedAt: now,
    };
};
//# sourceMappingURL=news.js.map